const breadcrumbs = Object.freeze({
  home: "Inicio",
  vacancies: "Vacantes",
  jobs: "Trabajos",
  companies: "Empresas",
});

export default breadcrumbs;
